<template>
  <TableLayout :permissions="['business:member:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="主键" prop="id">
          <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建人编码" prop="creator">
          <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
        </el-form-item>
        <el-form-item label="更新人编码" prop="editor">
          <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="editDate">
          <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
        </el-form-item>
        <el-form-item label="是否删除0否 1是" prop="isdeleted">
          <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="searchForm.name" placeholder="请输入姓名" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="状态 0正常 1禁用" prop="status">
          <el-input v-model="searchForm.status" placeholder="请输入状态 0正常 1禁用" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="排序码" prop="sortnum">
          <el-input v-model="searchForm.sortnum" placeholder="请输入排序码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="imgurl">
          <el-input v-model="searchForm.imgurl" placeholder="请输入头像" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="searchForm.type" placeholder="请输入类型" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="所属组织编码（关联company)" prop="companyId">
          <el-input v-model="searchForm.companyId" placeholder="请输入所属组织编码（关联company)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="searchForm.email" placeholder="请输入邮箱" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="性别 0男 1女 2位置" prop="sex">
          <el-input v-model="searchForm.sex" placeholder="请输入性别 0男 1女 2位置" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="code">
          <el-input v-model="searchForm.code" placeholder="请输入工号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="企微标识" prop="qwId">
          <el-input v-model="searchForm.qwId" placeholder="请输入企微标识" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="证件号" prop="idcard">
          <el-input v-model="searchForm.idcard" placeholder="请输入证件号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="最近上线时间" prop="lastLoginDate">
          <el-date-picker v-model="searchForm.lastLoginDate" value-format="yyyy-MM-dd" placeholder="请输入最近上线时间" @change="search"/>
        </el-form-item>
        <el-form-item label="登录次数" prop="loginCount">
          <el-input v-model="searchForm.loginCount" placeholder="请输入登录次数" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:member:create', 'business:member:delete']">
        <li><el-button type="primary" @click="$refs.operaMemberWindow.open('新建人员信息表')" icon="el-icon-plus" v-permissions="['business:member:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:member:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0正常 1禁用" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="100px"></el-table-column>
        <el-table-column prop="imgurl" label="头像" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型" min-width="100px"></el-table-column>
        <el-table-column prop="companyId" label="所属组织编码（关联company)" min-width="100px"></el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="100px"></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="100px"></el-table-column>
        <el-table-column prop="sex" label="性别 0男 1女 2位置" min-width="100px"></el-table-column>
        <el-table-column prop="code" label="工号" min-width="100px"></el-table-column>
        <el-table-column prop="qwId" label="企微标识" min-width="100px"></el-table-column>
        <el-table-column prop="idcard" label="证件号" min-width="100px"></el-table-column>
        <el-table-column prop="lastLoginDate" label="最近上线时间" min-width="100px"></el-table-column>
        <el-table-column prop="loginCount" label="登录次数" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:member:update', 'business:member:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaMemberWindow.open('编辑人员信息表', row)" icon="el-icon-edit" v-permissions="['business:member:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:member:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaMemberWindow ref="operaMemberWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaMemberWindow from '@/components/business/OperaMemberWindow'
export default {
  name: 'Member',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaMemberWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        name: '',
        remark: '',
        status: '',
        sortnum: '',
        imgurl: '',
        type: '',
        companyId: '',
        phone: '',
        email: '',
        sex: '',
        code: '',
        qwId: '',
        idcard: '',
        lastLoginDate: '',
        loginCount: ''
      }
    }
  },
  created () {
    this.config({
      module: '人员信息表',
      api: '/business/member',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
